// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");
var RatingSmileySet$ReactHooksTemplate = require("./ratingSmileySet.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function SmileyRatingEditor(props) {
  var onSmileyRatingChange = props.onSmileyRatingChange;
  var smileyRating = props.smileyRating;
  React.useEffect((function (param) {
          var match = SmileyRating$ReactHooksTemplate.ratingSmileySet(smileyRating);
          if (match !== undefined) {
            
          } else {
            Js_promise.then_((function (ratingSmileySet) {
                    return Promise.resolve(Curry._1(onSmileyRatingChange, SmileyRating$ReactHooksTemplate.setRatingSmileySet(smileyRating, ratingSmileySet)));
                  }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/rating_smiley_sets/default", (function (json) {
                        return Json_decode.field("rating_smiley_set", RatingSmileySet$ReactHooksTemplate.fromJson, json);
                      })));
          }
        }), [smileyRating]);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                    mandatory: props.mandatory,
                    onMandatoryChange: props.onMandatoryChange
                  })
            });
}

var make = SmileyRatingEditor;

exports.make = make;
/* react Not a pure module */
